<template>
    <div class="container">
        <h1 class="titulo">📄 LISTA DE DOCUMENTOS PÚBLICOS - CIM-AMREC</h1>

        <div class="filtro-grupo">
            <select v-model="grupoSelecionado" @change="filtrarPorGrupo" class="select-grupo">
                <option v-for="grupo in gruposDisponiveis" :key="grupo" :value="grupo">
                    {{ grupo }}
                </option>
            </select>
        </div>
        

        <div v-if="isLoading" class="loading">
            <span class="spinner"></span> Carregando...
        </div>


        <div v-for="(arquivos, pasta) in pastasAgrupadas" :key="pasta" class="pasta">
            <button class="btn-pasta" @click="togglePasta(pasta)">
                {{ pasta }}
                <span v-if="pastaAberta[pasta]">▲</span>
                <span v-else>▼</span>
            </button>

            <div v-if="pastaAberta[pasta]" class="arquivos">
                <div v-for="arquivo in arquivos" :key="arquivo.id" class="card-arquivo">
                    <div class="info-arquivo">
                        <div class="texto-arquivo">
                            <h3>{{ arquivo.nmdoc }}</h3>
                            <p>{{ arquivo.obspostagem }}</p>
                        </div>
                        <div class="acao-arquivo">
                            <button class="btn-icon" @click="visualizarAnexo(arquivo)" aria-label="Baixar documento">
                                <img :src="getIconPath()" alt="Download" class="icon-svg" />
                            </button>
                            <span class="tamanho">{{ formatarTamanho(arquivo.fsize) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="msgAlerta" class="alerta">{{ msgAlerta }}</div>
    </div>
</template>


<script setup>
import { Api } from '@/funcoes/apiExport';
import { onMounted, ref } from 'vue';

const lsDados = ref([]);
const pastasAgrupadas = ref({});
const pastaAberta = ref({});
const msgAlerta = ref(null);
const isLoading = ref(false);

const grupoSelecionado = ref('');
const gruposDisponiveis = ref([]);

function agruparPorPasta(lista) {
    const agrupado = {};
    lista.forEach(item => {
        if (!agrupado[item.nmpasta]) agrupado[item.nmpasta] = [];
        agrupado[item.nmpasta].push(item);
    });
    return agrupado;
}

function filtrarPorGrupo() {
    const filtrados = grupoSelecionado.value
        ? lsDados.value.filter(item => item.nmdrivegrupo === grupoSelecionado.value)
        : lsDados.value;
    pastasAgrupadas.value = agruparPorPasta(filtrados);
}

function formatarTamanho(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    else if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    else return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function getIconPath() {
  return require('@/assets/icons/download.svg');
}

function obterGrupos(lista) {
    const grupos = new Set(lista.map(item => item.nmdrivegrupo));
    return Array.from(grupos);
}

function togglePasta(pasta) {
  pastaAberta.value[pasta] = !pastaAberta.value[pasta];
}

async function listarAquivos(){
    try {
        const resposta = await Api.publicPost('/public/drive/arquivos', { idep: 1, strparam1: 'S' });
        lsDados.value = resposta;
        gruposDisponiveis.value = obterGrupos(resposta);
        grupoSelecionado.value = gruposDisponiveis.value[0];
        filtrarPorGrupo();
    } catch (error) {
        console.log(error);
    }
}

async function visualizarAnexo(obj) {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        if (obj.storage_cdtipo === 2){
            const r = await Api.genericPost('/operacoes/solicitar/download', {id: obj.idanexo});
            if (r.bolok === 1){
                const url = r.download_url;
                window.open(url, '_blank');
            }
        }else{
            const response = await Api.publicAnexo(obj.idanexo);
            const pdfBlob = new Blob([response], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

onMounted(listarAquivos)
</script>


<style scoped>
.acao-arquivo {
    width: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}
.alerta {
    margin-top: 20px;
    color: red;
    font-weight: bold;
}
.arquivos {
    margin-top: 10px;
    padding-left: 10px;
}
.btn-icon {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.btn-icon svg {
    display: block;
}
.btn-pasta {
    background-color: #297476;
    color: white;
    padding: 10px 15px;
    border: none;
    font-weight: bold;
    cursor: pointer;
    width: 100%;
    text-align: left;
}
.card-arquivo {
    background-color: #f4f4f4;
    border-radius: 8px;
    padding: 5px 10px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.card-arquivo h3 {
    margin: 0 0 5px;
}
.container {
    max-width: 900px;
    margin: auto;
    padding: 20px;
    font-family: sans-serif;
}
.filtro-grupo {
    margin-bottom: 20px;
}
.icon-svg {
    width: 24px;
    height: 24px;
    display: block;
}
.info-arquivo {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
}
.loading {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: bold;
    color: #005baa;
    margin-bottom: 20px;
}
.pasta {
    margin-bottom: 20px;
}
.select-grupo {
    background-color: #1d5153;
    color: white;
    padding: 10px 15px;
    border: none;
    font-weight: bold;
    cursor: pointer;
    width: 100%;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    font-size: 16px;
    /* Remove a seta padrão */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    /* Remove a seta no Firefox */
    background-image: none;
}
.spinner {
    width: 20px;
    height: 20px;
    border: 3px solid #ccc;
    border-top: 3px solid #005baa;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
.tamanho {
    font-size: 11px;
    color: #666;
    text-align: center;
}
.texto-arquivo {
    flex: 1;
    text-align: left;
}
.texto-arquivo h3 {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
    color: #222;
}
.texto-arquivo p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #444;
}
.titulo {
    text-align: center;
    margin-bottom: 40px;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>